import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from '../app/login/login.component'
import {MenuComponent} from '../app/menu/menu.component'
import {DataComponent} from '../app/data/data.component'
import {ComponenteData5Component }from '../app/componente-data5/componente-data5.component'
import {ComponenteData4Component}from '../app/componente-data4/componente-data4.component'
import { ComponenteData7Component } from './componente-data7/componente-data7.component';
import { GuardServiceGuard } from './guard-service.guard';



const routes: Routes = [
  { path: 'login-component', component: LoginComponent },
  { path: 'menu-component', component: MenuComponent,canActivate: [GuardServiceGuard] },
  { path: 'data-component', component: DataComponent,canActivate: [GuardServiceGuard] },
  { path: 'ComponenteData5Component', component: ComponenteData5Component,canActivate: [GuardServiceGuard] },
  { path: 'ComponenteData4Component', component: ComponenteData4Component,canActivate: [GuardServiceGuard] },
  { path: 'ComponenteData7Component', component: ComponenteData7Component,canActivate: [GuardServiceGuard] },
  
  { path: '**'  , component:LoginComponent  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
